import React from 'react';
import { useTranslation } from 'react-i18next';
import IForm from '../../../types/IForm';
import { Namespace } from '../../../translation/namespace';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';

type AppLibraryDeleteForm = {
  form: IForm;
  refresh(): void;
};

export function AppLibraryDeleteForm({ form, refresh }: AppLibraryDeleteForm) {
  const { t } = useTranslation(Namespace.AppLibrary);

  return (
    <AcceptDeclineForm
      form={form as any}
      headline={t('deleteForm.question')}
      onSuccess={refresh}
      messageSuccess={t('deleteForm.status.success')}
      messageSending={t('deleteForm.status.sending')}
      messageFail={t('deleteForm.status.fail')}
    />
  );
}
